const FORCE_ACTIVATE_USER_DEFAULT_VALUES = {
  delivery_state: 'MS',
  power_fase: 'monofásico',
  structure_type: 'ceramico',
  system_potency: '8',
  voltage: '220',
}

export { FORCE_ACTIVATE_USER_DEFAULT_VALUES }
